// Centralized site copy & constants for Esthera RealityOS

export const BRAND = {
  name: "Esthera RealityOS",
  short: "Esthera",
  tagline: "AI THAT WORKS. INTELLIGENCE THAT GROWS.",
  positioning: "The AI Operating System For Real Estate.",
  logo: "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/7tzd32bz_logo-estherarealityos-main.png",
};

export const SOCIAL_LINKS = [
  { key: "linkedin",  href: "https://www.linkedin.com/in/nishq-rajaram-30bb62420", label: "LinkedIn",  active: true },
  { key: "twitter",   href: null,                                                    label: "Twitter — coming soon",  active: false },
  { key: "instagram", href: "https://www.instagram.com/nishqr.esthera",             label: "Instagram", active: true },
  { key: "youtube",   href: null,                                                    label: "YouTube — coming soon",  active: false },
];

export const IMAGES = {
  // User-uploaded brand visuals (do not replace with stock)
  // Image 1 — Hero skyline with sapphire intelligence network
  heroSkyline:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/gd09fzgg_file_000000003de4720bbc4458e95ec170e8.png",
  // Image 2 — Luxury waterfront glass building (Platform section)
  platformArch:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/bhlwjx66_file_0000000080b0720bbb72febe81f8cbca.png",
  // Image 3 — Crystal Intelligence Core (CTA)
  ctaCrystal:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/ft7ss4tz_file_000000008eb8720bad0a2ad1c353b1b0.png",
  // Image 3 — Hero Intelligence Hub (Platform page)
  platformHeroHub:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/1w8yyt56_IMG-20260613-WA0040.jpg",
  // Image 4 — Unified Data Foundation diagram (Platform page)
  platformDataFoundation:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/flc6spjl_IMG-20260613-WA0041.jpg",
  // Image 5 — Autonomous Intelligence Layer (Platform page)
  platformAutonomous:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/0btryi6q_IMG-20260613-WA0042.jpg",
  // Image 1 (Pass 2) — Enterprise Security Shield (full composition)
  platformSecurity:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/9meattx6_IMG-20260613-WA0043.jpg",
  // Image 2 (Pass 2) — CTA Crystal Network (full composition)
  ctaCrystalNetwork:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/kjd7dawu_IMG-20260613-WA0045.jpg",
  // (legacy aliases kept for compatibility)
  heroBuilding:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/bhlwjx66_file_0000000080b0720bbb72febe81f8cbca.png",
  archSecondary:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/bhlwjx66_file_0000000080b0720bbb72febe81f8cbca.png",
  trustSkyline:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/gd09fzgg_file_000000003de4720bbc4458e95ec170e8.png",
};

export const BRAND_LOGOS = {
  main: "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/7tzd32bz_logo-estherarealityos-main.png",
  // Icon-only crown crystal logo for the navbar (dark BG, blends via mix-blend-mode: screen)
  navbar: "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/rav8hn6y_logo-estherarealityos-icon.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Platform", href: "/platform" },
  { label: "Solutions", href: "/solutions" },
  { label: "Why Esthera", href: "/why-esthera" },
  { label: "Resources", href: "/resources" },
  { label: "Company", href: "/company" },
];

export const RESOURCES_IMAGES = {
  // Hero — night city skyline with floating intelligence icons wired into a sapphire network
  hero:        "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/w6unw18l_resources-hero.png",
  // Featured whitepaper book mockup — "The Real Estate Intelligence Playbook"
  playbook:    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/hdtec6ob_resources-featured-playbook.png",
  // Subtle blue intelligence band — used as card thumbnail + newsletter background
  band:        "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/s319zgvn_resources-newsletter-intelligence-band%20%281%29.png",
  // Final CTA — diamond crystal on sapphire/amber networked landscape
  ctaCrystal:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/wscsq9o5_resources-cta-intelligence-network.png",
};

export const SOLUTIONS_IMAGES = {
  // Hero hub diagram — RealityOS Core with 6 orbiting role nodes
  heroHub:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/qti04ts4_solutions-hero-orbit.png",
  // Card 1 — Brokerages (cinematic blue waterfront skyline)
  cardBrokerages:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/rsitvmtx_solutions-brokerages-skyline.png",
  // Card 2 — Developers (residential tower)
  cardDevelopers:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/2ndcc0ai_solutions-developers-residential-tower.png",
  // Card 3 — Investors (commercial asset)
  cardInvestors:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/th1t3x1z_solutions-investors-commercial-asset.png",
  // Card 4 — Property Teams (luxury residence)
  cardPropertyTeams:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/rzn11vsl_solutions-property-teams-luxury-residence.png",
  // Card 5 — Enterprises (financial district)
  cardEnterprises:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/qtyi9iib_solutions-enterprises-financial-district.png",
  // Background for "One Intelligence Layer" section — sapphire data stream
  intelligenceWave:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/sl80i5wj_solutions-home-feature-data-stream-1.png",
  // Final CTA crystal — tall sapphire monolith on starfield (mix-blend-mode: screen friendly)
  ctaDiamond:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/3y7vsxew_solutions-brand-crystal.jpg",
};

export const WHY_ESTHERA_IMAGES = {
  hero:       "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/kedjw6e6_why-esthera-hero-connected-skyline.png",
  chaos:      "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/0q81fgjc_why-esthera-traditional-software-chaos.png",
  unified:    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/ho6gepho_why-esthera-unified-intelligence-city.png",
  ctaCrystal: "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/dmdhi8s4_why-esthera-crystal-network-cta.png",
};

export const CONTACT_IMAGES = {
  hero:     "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/ze4ohdmy_contact-hero-global-network.png",
  regions:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/607lf4tz_contact-global-operations-hub.png",
  ctaWave:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/mzqvww4e_contact-connected-intelligence-network.png",
};

export const COMPANY_IMAGES = {
  // Hero — cinematic skyline with sapphire intelligence network
  hero:        "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/dkit9pzr_company-hero.png",
  // Five-pillar "How We Operate" — line-art intelligence icon set
  valuesIcons: "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/07bnzonf_company-values-intelligence-icon-set_cropped.png",
  // Leadership portrait — Nishq Rajaram (Founder)
  founder:     "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/y957zcvq_company-founder-nishq-color_cropped.png",
  // Esthera Ventures silver/metallic shield watermark
  ventures:    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/jlly6y4u_company-esthera-ventures-watermark.png",
  // "Where We're Going" — sapphire/amber neural-network band (swapped per user direction)
  visionBand:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/pamkeb73_company-cta-intelligence-network_cropped.png",
  // Final CTA — tall standalone crystal on mountains/starfield (swapped per user direction)
  ctaCrystal:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/u6dctob6_company-vision-crystal-band_cropped.png",
};

export const BOOK_DEMO_IMAGES = {
  hero:        "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/jqr1vtb1_book-demo-hero-executive-dashboard.png",
  challenge:   "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/quvmqv0c_book-demo-current-state-chaos.png",
  future:      "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/pq0ut0jk_book-demo-future-state-connected-city.png",
  boardroom:   "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/are1gxic_book-demo-executive-boardroom.png",
  // CTA bottom — golden mesh network + sapphire skyline (Transform The Way You Operate Real Estate)
  ctaSkyline:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/o1m517a2_book-demo-final-cta-network.png",
};

export const PROPERTY_TEAMS_IMAGES = {
  hero:     "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/gyilwqeh_solutions-property-teams-hero.png",
  results:  "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/461c1o26_solutions-property-teams-results-visual.png",
  auditCta: "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/80fo2os5_solutions-property-teams-audit-cta-network_cropped.png",
};

export const INVESTORS_IMAGES = {
  // Hero — financial-district night skyline wired into a sapphire mesh, water reflections
  hero:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/76p7g76v_solutions-investors-hero.png",
  // Real Results — 3D investment dashboard (Portfolio Performance, Risk, Market Trends, etc.)
  results:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/4qcsgl9v_solutions-investors-results-visual.png",
  // Audit CTA — sapphire diamond crystal on starfield network
  auditCta:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/mf49nk6u_solutions-investors-audit-cta-network_cropped.png",
};

export const ENTERPRISES_IMAGES = {
  // Hero — financial-district city skyline wired into a sapphire mesh network
  hero:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/7nc3oi30_solutions-enterprises-hero.png",
  // Real Results — 3D operations city + KPI dashboard panels
  results:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/j5dwudjp_solutions-enterprises-results-visual.png",
  // Audit CTA — sapphire diamond on starfield network
  auditCta:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/72w3arot_solutions-enterprises-audit-cta-network_cropped.png",
};

export const DEVELOPERS_IMAGES = {
  // Hero — blueprint towers + tower cranes wired into a sapphire network
  hero:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/h2jy71a6_solutions-developers-hero.png",
  // Results section — three towers with KPI labels (87%, +42%, 68%) + label legend on left
  results:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/cwl81b1j_solutions-developers-results-visual.png",
  // Final CTA — sapphire diamond crystal on data-network starfield
  auditCta:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/25gk9p1d_solutions-developers-audit-cta-network_cropped.png",
};

export const BROKERAGES_IMAGES = {
  // Hero — NY night skyline with sapphire connection network
  hero:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/cv90dlxy_solutions-brokerages-hero.png",
  // Results section — labeled sapphire funnel diagram
  funnel:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/0cow9ek0_solutions-brokerages-results-funnel.png",
  // Final CTA — diamond crystal on sapphire data network
  auditCta:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/ak5964bl_solutions-brokerages-audit-cta-network_cropped.png",
};

export const AUDIT_IMAGES = {
  // Hero crystal-with-city composition for the Audit Report page
  heroCrystalCity:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/kiucfcqg_get-your-audit-hero-crystal.png",
  // Neon building logo (used on this page only)
  buildingLogo:
    "https://customer-assets.emergentagent.com/job_realityos-ai/artifacts/y3t2sjii_get-your-audit-credibility-icon.png",
};

export const KPI_ITEMS = [];

export const CAPABILITIES = [
  { icon: "ShieldCheck", title: "Enterprise Security", desc: "Bank-grade governance and data controls." },
  { icon: "Bot", title: "AI-Driven Operations", desc: "Predictive workflows that learn continuously." },
  { icon: "Activity", title: "Real-Time Intelligence", desc: "Always-on signal across data, teams, deals." },
  { icon: "Workflow", title: "Workflow Automation", desc: "Eliminate friction. Codify excellence." },
  { icon: "Database", title: "Data Unification", desc: "One source of truth across the portfolio." },
  { icon: "LineChart", title: "Predictive Analytics", desc: "Forecasting that scales with your pipeline." },
];

export const ECOSYSTEM_STAGES = [
  { key: "capture", title: "Capture", desc: "Omnichannel lead capture with AI", icon: "Crosshair" },
  { key: "qualify", title: "Qualify", desc: "AI-powered lead qualification", icon: "Sparkles" },
  { key: "route", title: "Route", desc: "Intelligent routing to the right teams", icon: "Workflow" },
  { key: "engage", title: "Engage", desc: "Personalized engagement across channels", icon: "MessagesSquare" },
  { key: "convert", title: "Convert", desc: "Streamlined deals, workflows & approvals", icon: "CheckCircle2" },
  { key: "intelligence", title: "Intelligence", desc: "Real-time analytics and actionable insights", icon: "BarChart3" },
];

export const PLATFORM_BULLETS = [
  "AI-Powered Lead Capture",
  "Unified CRM Intelligence",
  "Sales Intelligence & Forecasting",
  "Marketing Automation",
  "End-to-End Integrations",
  "Real-Time Analytics",
];

export const PILLARS = [
  { icon: "ShieldCheck", title: "Enterprise Security", desc: "Bank-grade security, compliance, and governance." },
  { icon: "Activity", title: "Real-Time Intelligence", desc: "Live visibility across teams, data, and performance." },
  { icon: "Zap", title: "AI Automation", desc: "Automate workflows, eliminate manual work." },
  { icon: "Workflow", title: "Workflow Intelligence", desc: "Optimize operations with AI-driven recommendations." },
  { icon: "Building2", title: "Built for Real Estate", desc: "Purpose-built for developers, brokerages, and investors." },
];

export const RESULTS = [];

export const TRUST_PILLARS = [
  { label: "Enterprise Security" },
  { label: "AI-Driven Operations" },
  { label: "Real-Time Intelligence" },
  { label: "Workflow Automation" },
  { label: "Data Unification" },
  { label: "Predictive Analytics" },
];

// Footer navigation — standardized structure used on every page.
// Links to pages that aren't live yet (Resources, Book a Demo) are hidden here
// per the 2026-08 spec; re-enable once those pages are ready.
export const FOOTER_COLUMNS = [
  {
    title: "Product",
    items: [
      { label: "Home",     href: "/" },
      { label: "Platform", href: "/platform" },
    ],
  },
  {
    title: "Solutions",
    items: [
      { label: "Brokerages",      href: "/solutions/brokerages" },
      { label: "Developers",      href: "/solutions/developers" },
      { label: "Investors",       href: "/solutions/investors" },
      { label: "Property Teams",  href: "/solutions/property-teams" },
      { label: "Enterprises",     href: "/solutions/enterprises" },
    ],
  },
  {
    title: "Company",
    items: [
      { label: "Why Esthera", href: "/why-esthera" },
      { label: "About",       href: "/company" },
      { label: "Contact",     href: "/contact" },
    ],
  },
  {
    title: "Legal",
    items: [
      { label: "Privacy Policy",    href: "/privacy" },
      { label: "Terms of Service",  href: "/terms" },
    ],
  },
];

export const TRUST_LINE = [
  "Enterprise-grade reliability",
  "SOC 2 Type II",
  "ISO 27001",
  "WCAG 2.1 AAA",
  "Enterprise SSO",
  "GDPR & DPDP compliant",
  "Always-on success",
];
